<template>
  <div class="container">
    <!-- 悬浮顶部栏 -->
    <HeaderFullCmp @onExitFull="exitFullScreen" v-if="isFS" class="floating_header" />
    <HeaderCmp @onFullScreen="fullScreen" v-else class="floating_header" />

    <!-- 底层全屏视频 -->
    <div class="video_layer">
      <ContentRightCmp :isFS="isFS" />
    </div>

    <!-- 可折叠左侧设备抽屉 -->
    <div class="sidebar_drawer" :class="{ collapsed: sidebarCollapsed }" v-if="!isFS">
      <div class="drawer_content">
        <ContentLeftCmp />
      </div>
      <div class="drawer_toggle" @click="toggleSidebar" title="收起/展开">
        <div class="arrow" :class="{ right: sidebarCollapsed }"></div>
      </div>
    </div>

    <!-- 底部状态栏 -->
    <div class="bottom_status_bar" v-if="!isFS">
      <div class="status_left">
        <div class="status_item">
          <span class="dot online"></span>
          <span class="label">系统运行正常</span>
        </div>
        <div class="status_divider"></div>
        <div class="status_item">
          <span class="label">设备总数</span>
          <span class="value">1023</span>
        </div>
        <div class="status_divider"></div>
        <div class="status_item">
          <span class="label">轮巡</span>
          <span class="value" :class="{ active: isLoop }">{{ isLoop ? '已开启' : '已关闭' }}</span>
        </div>
      </div>
      <div class="status_right">
        <span class="status_time">{{ currentTime }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderFullCmp from './HeaderFullCmp';
import HeaderCmp from './HeaderCmp';
import ContentLeftCmp from './ContentLeftCmp';
import ContentRightCmp from './ContentRightCmp';

export default {
  name: 'ShuifaData',
  components: {
    HeaderCmp, HeaderFullCmp, ContentLeftCmp, ContentRightCmp
  },
  data() {
    return {
      sidebarCollapsed: false,
      currentTime: '',
      timeTimer: null
    }
  },
  computed: {
    isFS() {
      return this.$store.state.isFullScreen;
    },
    isLoop() {
      return this.$store.state.isLoop;
    }
  },
  mounted() {
    let _this = this;
    let res1 = _this.isOrNoFullScreen();
    _this.$store.dispatch("doChangeFullScreen", res1);
    window.onresize = () => {
      let res = this.isOrNoFullScreen();
      _this.$store.dispatch("doChangeFullScreen", res);
    }
    this.updateTime();
    this.timeTimer = setInterval(() => {
      this.updateTime();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timeTimer) {
      clearInterval(this.timeTimer);
    }
  },
  methods: {
    isOrNoFullScreen() {
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (clientHeight === window.screen.height) {
        return true
      } else {
        return false
      }
    },
    fullScreen() {
      var docElm = document.documentElement;
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
      this.$store.dispatch("doChangeFullScreen", true);
    },
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.$store.dispatch("doChangeFullScreen", false);
    },
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    },
    updateTime() {
      const now = new Date();
      const pad = (n) => n < 10 ? '0' + n : n;
      this.currentTime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  background: #0b1120;
}

.floating_header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}

.video_layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

/* 左侧抽屉 */
.sidebar_drawer {
  position: absolute;
  top: 64px;
  left: 0;
  bottom: 32px;
  width: 280px;
  z-index: 50;
  display: flex;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar_drawer.collapsed {
  transform: translateX(-280px);
}

.drawer_content {
  flex: 1;
  background: rgba(15, 23, 42, 0.95);
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.drawer_toggle {
  position: absolute;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 60px;
  background: rgba(15, 23, 42, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-left: none;
  border-radius: 0 6px 6px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
}

.drawer_toggle:hover {
  background: rgba(30, 41, 59, 0.95);
}

.arrow {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 6px solid #94a3b8;
  transition: all 0.3s;
}

.arrow.right {
  border-right: none;
  border-left: 6px solid #94a3b8;
}

/* 底部状态栏 */
.bottom_status_bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 32px;
  background: rgba(15, 23, 42, 0.9);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(8px);
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.status_left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status_item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.status_item .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #475569;
}

.status_item .dot.online {
  background: #10b981;
  box-shadow: 0 0 6px rgba(16, 185, 129, 0.4);
}

.status_item .label {
  color: #64748b;
}

.status_item .value {
  color: #94a3b8;
  font-weight: 500;
}

.status_item .value.active {
  color: #3b82f6;
}

.status_divider {
  width: 1px;
  height: 12px;
  background: rgba(255, 255, 255, 0.08);
}

.status_right {
  font-size: 12px;
  color: #94a3b8;
  font-family: 'Courier New', monospace;
  letter-spacing: 0.5px;
}
</style>
